// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserStatus-module__container--R6cIH{display:flex;align-items:center;color:#db3737;font-size:13px;margin-right:15px;margin-left:auto}.UserStatus-module__container--R6cIH.UserStatus-module__allowed--bwb1T{color:#35b840}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UserStatus-module__container--R6cIH`,
	"allowed": `UserStatus-module__allowed--bwb1T`
};
export default ___CSS_LOADER_EXPORT___;
